export const CURRENT_DOMAIN = 'uef';

const DOMAINS = {
  uef: 'https://lib.uef.edu.vn/',
};

export default DOMAINS;
